import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { queryOptions_theme } from "@/lib/providers/query/functions/theme";
import { ThemeContext } from "@/lib/providers/theme/context";
import { DEFAULT_THEME } from "@/lib/theme/themes/default";
import { type Theme } from "@/lib/theme/type";
import { appendRgbToCssVars, convertThemeToCssVars } from "@/lib/theme/utils";
import { useCssVars } from "@/utils/css-vars";

export function ThemeProvider(props: React.PropsWithChildren) {
  const query = useQuery(
    queryOptions_theme({
      slug: import.meta.env.VITE_ORGANIZATION_SLUG ?? "default",
    }),
  );
  const theme = useMemo(() => {
    // const themeConfig = query.data;

    // const theme = (themeConfig?.config ?? DEFAULT_THEME) as Theme;
    // return theme;

    // Swagger type from API is wrong actually it is already Theme
    return (query.data as unknown as Theme) || DEFAULT_THEME;
  }, [query.data, DEFAULT_THEME]);

  useCssVars(appendRgbToCssVars(convertThemeToCssVars(theme)));

  return <ThemeContext.Provider value={{ theme }}>{props.children}</ThemeContext.Provider>;
}
